import {Config, Settings, Source, State, RollState, Vast, PlayerConfig} from "./interfaces/videoplayer.interfaces";
import {Player as VideoJSPlayer} from "videojs";
declare global {
    interface Window { videojs: any;
    }
}


const videojs = require('video.js')
window.videojs = videojs;
require('videojs-contrib-hls')
const DMVAST = require('vast-client')


export class Player {

    private container: Element;
    private fluid: boolean;
    private proportions: string;
    private controls: boolean;
    private sources: Array<Source>;
    private autoplay: boolean;
    private preload: boolean;
    private player: Player;
    private settings: Settings;
    private preroll: string;
    private postroll: string;
    private norolls: boolean;
    private poster: string;
    private videos: Array<VideoJSPlayer>;
    private videojs: any;
    private state: State;
    private playsinline: boolean;
    private loop: boolean;



    constructor(config: Config) {
        this.player = this;
        let _player = this;


        // Remove signing from the urls, as all files are accessable from the whole internet (should probably be geolocked)
        for (let s of config.sources) {
            s.src = s.src.substr(0, s.src.indexOf("?"));
            s.extension = s.src.split('.').pop();
        }

        // Reverse array of video sources, as Escenic puts the preferred source last in the array. Should be refactored to use a dictionary/map
        config.sources.reverse();

        this.container = config.container;
        this.sources = config.sources;
        this.fluid = config.fluid == undefined ? true : config.fluid;
        this.autoplay = config.autoplay == undefined ? false : config.autoplay;
        this.preload = config.preload == undefined ? true : config.preload;
        this.preroll = config.preroll == undefined ? "" : config.preroll;
        this.postroll = config.postroll == undefined ? "" : config.postroll;
        this.norolls = config.norolls == undefined ? false : config.norolls;
        this.proportions = config.proportions == undefined ? "16:9" : config.proportions;
        this.controls = config.controls == undefined ? true : config.controls;
        this.settings = config.settings == undefined ? this.getDefaultSettings(config.sources) : config.settings;
        this.poster = config.poster == undefined ? "" : config.poster;
        this.playsinline = config.playsinline == undefined ? true : config.playsinline;
        this.loop = config.loop == undefined ? false : config.loop;
        _player.videos = videojs.getPlayers();


        let playerConfig : PlayerConfig = {
            fluid: this.fluid,
            proportions: this.proportions,
            preload: this.preload,
            controls: this.controls,
            autoplay: this.autoplay,
            poster: this.poster,
            playsinline: this.playsinline,
            loop: this.loop
        };

        this.state = {
            adPlaying: false,
            preroll: {
                played: false
            },
            postroll: {
                played: false
            },
            played: false,
            preOrPostPlaying: ""
        };


        videojs(
            this.container,
            playerConfig, function () {
                _player.videojs = this;

                _player.videojs.src(_player.sources);

                // makes it easier to inspect each videos properties
                _player.videojs.el_.debug = {
                    state: _player.state,
                    settings: _player.settings
                }


                /*
                 Pause other player when video plays... not sure if we really want this... can be disabled in settings

                 This needs refactoring in Typescript
                 */

                if (!_player.isMobileAgent() && _player.settings.onlyOneVideoPlayingAtATime) {
                    this.on('play', function() {
                        // when this player plays, we run through the players on the page and pause the others
                        for(var n in _player.videos){
                            var currentPlayer = _player.videos[n];
                            // if 'somePlayer' is not this player and it is playing, we pause it.
                            if(currentPlayer !== _player.videojs && !currentPlayer.paused()){
                                currentPlayer.pause();
                            }
                        }
                    })
                };


                /*
                 When the page loads, and the player has loaded the first
                 bit of content, we pause and check for preroll content.

                 We call requestAd for preroll in a timeout.
                 If it fails, is calls back immidiately to resume
                 playback of main content by calling playMainContent();

                 (requestAd for postroll is called after main content starts playing)

                 */

                _player.videojs.on('ready', function () {
                    _player.debug('Initial play - pause and check for preroll.');

                    /*
                     If the player is autoplaying, an 'hide-jppolvp-until-loaded' class is
                     added to the player, masking all content. and avoiding a
                     short flash of the first frame from the main content.
                     The class is removed 35 ms after the first time this player plays anything.
                     */

                    _player.videojs.addClass('jppolvp-hide-video-element');
                    _player.videojs.one('play', function () {
                        _player.debug('The first time this player plays anything. Should never see this again from this player');
                        window.setTimeout(function () {
                            _player.videojs.removeClass('hide-jppolvp-until-loaded');
                            _player.videojs.removeClass('jppolvp-hide-video-element');
                        }, 50);
                    });

                    // remove native poster
                    _player.videojs.el_.querySelector('video').poster = '';

                    /*
                     hide videoelement to avoid flash of main content
                     until we know if we should play a preroll
                     */

                    if (_player.videojs.autoplay()) {
                        _player.debug("Autoplay detected...");
                        if (_player.isMobileAgent()) {
                            /*
                             Autoplay not allowed on mobile if the clip has unmuted audio.
                             So we just show the player...
                             */
                            _player.videojs.removeClass('hide-jppolvp-until-loaded');
                            _player.videojs.removeClass('jppolvp-hide-video-element');
                        }
                        _player.videojs.posterImage.hide();
                    }
                    ;

                    var vastAsyncCall = setTimeout(function () {
                        videojs.log.warn("'Async timeout for ad VAST-file reached - starting main content playback");
                        _player.playMainContent();
                    }, _player.settings.adAsyncTimeout);


                    _player.requestAd('preroll', function callback(result: any) {
                        _player.debug('In callback from preroll');
                        clearTimeout(vastAsyncCall);
                        if (!result) {
                            _player.debug('Got no preroll, resume content');
                            _player.playMainContent();
                        } else {
                            _player.debug('Got preroll, playing preroll');

                            if (!_player.videojs.paused()) {
                                _player.playAd('preroll');
                            } else {
                                _player.videojs.one('play', function () {
                                    _player.playAd('preroll');
                                });
                            }
                        }
                    });
                });
            });


    }

    private playAd(position: string) {


        var adObj: Vast;
        var state = this.state;
        var rollState: RollState;
        let _player = this;

        if (_player.norolls) {
            _player.debug('Pre-/postrolls deactivated');
            return;
        }

        _player.debug('Attempting to play ' + position);


        if (position == 'preroll') {
            adObj = _player.settings.preroll;
            rollState = state.preroll;
        } else {
            adObj = _player.settings.postroll;
            rollState = state.postroll;
        }

        _player.videojs.src(adObj.mediaSrc);
        _player.videojs.play();
        _player.videojs.addClass('vjs-ad-playing');

        rollState.played = true;
        state.adPlaying = true;
        state.preOrPostPlaying = position;

        _player.initiateAdTracking(adObj);

        _player.videojs.one('play', function () {

            // calls 'creativeView' ad-tracking event (the ad is visible)
            adObj.tracker.load();
            // insert clicklayer and skipbutton
            _player.createAdClickLayer(adObj);
            _player.createAdSkipButton(adObj);
        });

        _player.videojs.one('error', function () {
            _player.videojs.el_.querySelector('video').setAttribute('style', ''); // damn you, adblock on safari!
            videojs.log(position + ' failed to play');
            _player.playMainContent();
        });

        //When an ad has finished playing without user skipping
        _player.videojs.one('ended', function () {
            _player.debug(position + ' ended');
            // calls 'complete' ad-tracking event
            //adObj.tracker.complete();
            _player.playMainContent();
        });
    };


    private playMainContent() {
        let _player = this;
        _player.removeAdSkipButton();
        _player.removeAdClickLayer();
        _player.videojs.removeClass('vjs-ad-playing');
        _player.state.adPlaying = false;


        if (_player.state.preroll.played || this.state.postroll.played) {
            _player.debug('Coming from either pre- or postroll. Reloading main content.');
            _player.videojs.src(_player.settings.originalContent);
            _player.videojs.play();
        }

        if((_player.state.played) && (_player.state.postroll.played || !_player.settings.postroll.tracker)){
            _player.videojs.pause();
            if(_player.settings.posterImage){
                _player.videojs.load();
            }
            let videoElement = window.document.getElementById(_player.videojs.id()).querySelector("video");

            videoElement.addEventListener("play", function fn(){
                _player.videojs.pause();
                videoElement.autoplay = false;
                videoElement.removeEventListener("play", fn);
            });
        } else {
            _player.state.played = true;
        }

        /*
         If we are playing maincontent and either postroll has played or we didn't have postroll to play,
         we attach the image-url from 'data-poster' attribute, if present, so it shows after maincontent stops.
         */
        if (_player.settings.posterImage && (_player.state.postroll.played || _player.settings.postroll.getVastUrlsFailed)) {
            _player.debug('If we got a postroll and it played, load the previously detached posterframe');
            _player.videojs.one('play', function () {
                _player.videojs.poster(this.settings.posterImage);
            });
        }

        if (_player.state.postroll.played) {
            _player.videojs.addClass('jppolvp-force-show-poster');
        }

        /*
         Getting postroll vasturls was not attempted yet.
         Trying to get postroll vasturls while main content plays.
         */

        if (!_player.settings.postroll.getVastUrlsFailed) {
            _player.debug('Main content playing - trying to get postroll');
            _player.requestAd('postroll', function (status: any) {
                _player.debug('Getting postroll ' + (status ? 'was successful' : 'failed'));
            });
        }

        _player.videojs.one('ended', function () {
            /*
             If we got postroll vasturls and postroll isn't played yet,
             play a postroll. Otherwise we are done.
             */
            if (!_player.settings.postroll.getVastUrlsFailed && !_player.state.postroll.played) {
                _player.playAd('postroll');
            }
        });

        if (_player.state.postroll.played) { //load main content and go to last frame.
            _player.videojs.one('loadeddata', function () {
                _player.videojs.pause();
                _player.videojs.one('play', function () {
                    _player.videojs.removeClass('jppolvp-force-show-poster');
                    _player.debug('Should only see this once!');
                });
            });
        }
    };


    /*
     Calls the supplied adform xml-files
     */

    private requestAd(position: string, retFn: Function) { // position can be 'preroll' or 'postroll'
        let _player = this;
        _player.debug("Request ad for position " + position);

        var thisAdSetting: Vast = position == 'preroll' ? _player.settings.preroll : _player.settings.postroll;

        if (!thisAdSetting.vastUrl) {
            thisAdSetting.getVastUrlsFailed = true;
            if (retFn) {
                retFn(false);
            }
            return;
        }

        DMVAST.client.get(thisAdSetting.vastUrl, function (response: any, error: any) {
            _player.debug("Getting vast content " + thisAdSetting.vastUrl);
            if (response && response.ads.length) {

                _player.debug(response);

                var ad, creative, mediaSrc, clickThroughUrl;

                ad = response.ads[0];

                if (!ad.creatives.length) {
                    thisAdSetting.getVastUrlsFailed = true;
                    if (retFn) {
                        retFn(false);
                    }
                    return;
                } else {
                    creative = ad.creatives[0];
                }

                clickThroughUrl = creative.videoClickThroughURLTemplate;

                for (var mediafile in creative.mediaFiles) {
                    if (_player.videojs.canPlayType(creative.mediaFiles[mediafile].mimeType)) {
                        mediaSrc = creative.mediaFiles[mediafile].fileURL;
                        break;
                    }
                }

                // all good - add media and clickThrough to inventory
                thisAdSetting.mediaSrc = mediaSrc;
                thisAdSetting.clickThroughUrl = clickThroughUrl;
                thisAdSetting.getVastUrlsFailed = false;

                // setup event callbacks to advertiser
                thisAdSetting.tracker = new DMVAST.tracker(ad, creative);

                if (retFn) {
                    retFn(true);
                }
                return;

            } else {
                _player.debug('No response from supplied vast-urls. Or is your adblocker on?');
                thisAdSetting.getVastUrlsFailed = true;
                if (retFn) {
                    retFn(false);
                }
                return;
            }
        });
    };


    private debug(str: string) {
        if (this.settings.debug) {
            videojs.log('(#' + this.videojs.id() + '): ' + str);
        }
    }

    private getDefaultSettings(sources: Array<Source>): Settings {
        let settings: Settings = {
            preroll: {
                vastUrl: this.player.preroll,
                mediaSrc: null,
                clickThroughUrl: null,
                getVastUrlsFailed: false,
                tracker: null,
                skipTrackingUrl: null
            },
            postroll: {
                vastUrl: this.player.postroll,
                mediaSrc: null,
                clickThroughUrl: null,
                getVastUrlsFailed: false,
                tracker: null,
                skipTrackingUrl: null
            },
            adAsyncTimeout: 3000, // milliseconds we wait for call to ad-network to respond
            originalContent: sources,
            closeAd: '<span>Luk annonce</span> <span class="jppolcp-closebutton"></span>',
            closeAdWait: '<span>Annoncen kan lukkes om</span> ',
            closeAdWaitSeconds: [' <span>sekunder</span>', ' <span>sekund</span>'], // plural or singular
            debug: true,
            onlyOneVideoPlayingAtATime: true,
            posterImage: this.player.poster,
            skipAdTime: 10
        };
        return settings;
    }


    /*
     Create and remove skipbutton
     */

    createAdSkipButton(adObj: Vast): void {
        let _player = this;
        _player.debug('Create skip button for ' + _player.state.preOrPostPlaying);

        var skipButton = window.document.createElement('div');
        skipButton.className = "jppolvp-adSkipButton";
        _player.videojs.el().insertBefore(skipButton, _player.videojs.controlBar.el());

        var skipButtonEventAttached = false;
        _player.videojs.on('timeupdate', function () {
            var timeLeft = Math.floor(_player.settings.skipAdTime - _player.videojs.currentTime());
            if (!skipButtonEventAttached) {
                if (timeLeft > 0) {
                    skipButton.innerHTML = _player.settings.closeAdWait + timeLeft + _player.settings.closeAdWaitSeconds[timeLeft > 1 ? 0 : 1];
                } else {
                    skipButton.innerHTML = _player.settings.closeAd;
                    skipButton.onclick = function () {
                        _player.videojs.posterImage.hide();
                        _player.debug('Skipping ' + _player.state.preOrPostPlaying);
                        //track skip-event.
                        if (adObj.skipTrackingUrl) {
                            var i = new Image();
                            i.src = adObj.skipTrackingUrl;
                        }

                        _player.playMainContent();
                    };
                    skipButtonEventAttached = true;
                }
            }
        });
    };

    removeAdSkipButton(): void {
        let _player = this;
        var el = _player.videojs.el().querySelector('.jppolvp-adSkipButton');
        if (el) {
            el.parentNode.removeChild(el);
        }
    };

    /*
     Create and remove clicklayer
     */

    createAdClickLayer(adObj: Vast): void {
        let _player = this;
        _player.debug('Create click-layer for ' + _player.state.preOrPostPlaying);
        var adClickLayer = window.document.createElement("a");

        adClickLayer.className = "jppolvp-adClickLayer";
        adClickLayer.href = adObj.clickThroughUrl;
        adClickLayer.target = "_blank";

        adClickLayer.onclick = function () {
            if (!_player.videojs.paused()) {
                adObj.tracker.click();
                _player.videojs.pause();
            }
        };

        _player.videojs.el().insertBefore(adClickLayer, _player.videojs.controlBar.el());
    };

    removeAdClickLayer(): void {
        let _player = this;
        var el = _player.videojs.el().querySelector('.jppolvp-adClickLayer');
        if (el) {
            el.parentNode.removeChild(el);
        }
    };


    // eventhandlers for vast tracking
    initiateAdTracking(adObj: Vast) {
        var tracker = adObj.tracker;
        let _player = this;

        /*
         Uses build-in tracking functions from DMVAST
         Note: event 'id's will probably change

         'setProgress' sends back these events:
         event=25:	start
         event=26:	first Q
         event=27:	mid
         event=28:	third Q
         event=29:	complete
         */
        _player.videojs.on('timeupdate', function () {
            if (_player.state.adPlaying) {
                tracker.setProgress(_player.videojs.currentTime());
            }
        });

        // Handles event=31: pause
        _player.videojs.on('pause', function () {
            if (_player.state.adPlaying) {
                /*
                 html5 videos always fires a 'pause' event right before completion
                 so to avoid sending a non-user initiated pause-event, we mute pause events
                 if we are within the last second of a pre- or postroll
                 */
                if (_player.videojs.duration() - _player.videojs.currentTime() > 1) {
                    _player.debug('Pausing ' + _player.state.preOrPostPlaying);
                    tracker.setPaused(true);
                }
            }
        });

        // Handles event=37: resume
        _player.videojs.on('play', function () {
            if (_player.state.adPlaying) {
                if (_player.videojs.currentTime() > 1) {
                    _player.debug('Resuming ' + _player.state.preOrPostPlaying);
                    tracker.setPaused(false);
                }
            }
        });

        /*
         Handles:
         event=34:	mute
         event=33:	unmute
         */
        _player.videojs.on('volumechange', function () {
            if (_player.state.adPlaying) {
                _player.debug((_player.videojs.muted() ? 'muted ' : 'unmuted ') + _player.state.preOrPostPlaying);
                tracker.setMuted(_player.videojs.muted());
            }
        });

        /*
         VAST 2.0 doesn't include skip-event
         but Adform include it in a custom-node,
         if the ad is setup to be skippable in the
         ad backend tool. XML looks like this:
         <Extensions>
         <Extension>
         <CustomTracking>
         <Tracking event="skip">
         <![CDATA[
         http://url-to-skip-event-here
         ]]>
         </Tracking>
         </CustomTracking>
         </Extension>

         So we roll our own...

         Only problem is that the VAST parser doesn't get the event-attribute,
         so we have to rely on either only one (1) CustomTracking node under
         an Extension-node OR that the tracking url contains 'event=169'

         */

        if (tracker.ad.extensions && tracker.ad.extensions.length) {
            var extensions = tracker.ad.extensions;
            var skipTrackingUrl = null;
            for (var i = 0; i < extensions.length; i++) {
                if (extensions[i].children[0].name === 'CustomTracking') {
                    var url = extensions[i].children[0].value;
                    if (url.indexOf('event=169') != -1) {
                        skipTrackingUrl = url;
                        _player.debug("Got tracking url for " + _player.state.preOrPostPlaying + " 'skip' event");
                        break;
                    }
                }
            }
            adObj.skipTrackingUrl = skipTrackingUrl;
        }

        /*
         STILL TODO:
         event=35:	fullscreen
         event=38:	rewind
         event=23:	close
         */

    };


    private isMobileAgent(): boolean {
        return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    }

    private isMobileAgentModern(): boolean {
        return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|Opera Mini/i.test(navigator.userAgent));
    }

    private isMobileLayout(): boolean {
        return window.matchMedia ? window.matchMedia('screen and (max-width: 750px)').matches : false;
    }
}



// WEBPACK FOOTER //
// ./VideoPlayer/VideoPlayer.ts